// below is a bit cleaner approach:
// https://github.com/wix-private/document-management/blob/f6de33827d4ac6bf584c5211abadf18073ea9110/document-services-implementation/src/platform/core/workerFactory.js#L146-L150
export async function createWorkerBlobUrl(workerUrl: string) {
	const res = await fetch(workerUrl)
	const body = new Response(res.body)
	const blob = await body.blob()
	return URL.createObjectURL(blob)
}
